/**
 * After we have grouped the charts we want to merge the territories
 * with their corresponding meta data for things like flag images.
 *
 * @param {Array} charts the grouped charts
 * @param {Array} metadata array with metadata per territory
 * @returns {Array} the charts array with merged territory data.
 */
export default function mergeTerritoryData(charts: any, countries: any): any {
  return charts.map((chart: any): any => {
    const mergedTerritoryData = chart.territoryData.map(
      (territory: any): any => {
        const territoryId = territory.countryId;
        const match = countries.find(({ id }: any) => id === territoryId);

        if (match) {
          return Object.assign(territory, match);
        }
        if (territoryId === 'EU') {
          return Object.assign(territory, { displayName: 'European' });
        }
        return territory;
      }
    );
    chart.territoryData = mergedTerritoryData;
    return chart;
  });
}
